__turbopack_context__.v({
  "root": "IconCategoryWrapper-module-scss-module__M1pFvG__root",
});
